import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { EnvelopeIcon, ArrowPathIcon, CheckCircleIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../contexts/AuthContext';
import AuthLayout, { AuthInput, AuthLabel, AuthError, AuthLink } from '../components/ui/AuthLayout';
import { Button } from '../components/ui/button';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);

  const { resetPassword } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    setError('');

    const res = await resetPassword(email);
    setLoading(false);

    if (res.success) {
      setSent(true);
    } else {
      setError(res.error || 'Dështoi dërgimi i email-it. Provoni përsëri.');
    }
  };

  return (
    <AuthLayout
      title="Rivendos fjalëkalimin"
      subtitle="Shkruani email-in tuaj dhe do t'ju dërgojmë një lidhje për të vendosur një fjalëkalim të ri."
      footer={
        <>
          Kujtuat fjalëkalimin? <AuthLink to="/login">Kthehu te hyrja</AuthLink>
        </>
      }
    >
      {sent ? (
        <div className="space-y-5">
          <div className="rounded-xl border border-emerald-200 bg-emerald-50/80 p-4 text-sm text-emerald-900 flex items-start gap-3">
            <CheckCircleIcon className="w-5 h-5 text-emerald-600 shrink-0 mt-0.5" />
            <div>
              <p className="font-semibold mb-1">Email-i i rivendosjes u dërgua me sukses!</p>
              <p className="text-emerald-700 text-xs leading-relaxed">
                Kontrolloni kutinë tuaj hyrëse (dhe dosjen Spam) për <strong>{email}</strong>. Klikoni linkun e marrë për të vendosur fjalëkalimin e ri.
              </p>
            </div>
          </div>
          <Button asChild variant="outline" className="w-full h-10 border-zinc-200 hover:bg-zinc-100 text-zinc-900 font-medium">
            <Link to="/login">Kthehu te faqja e hyrjes</Link>
          </Button>
        </div>
      ) : (
        <form className="space-y-5" onSubmit={handleSubmit}>
          {error && <AuthError>{error}</AuthError>}

          <div className="space-y-1.5">
            <AuthLabel htmlFor="email">Adresa e Email-it</AuthLabel>
            <AuthInput
              id="email"
              name="email"
              type="email"
              icon={EnvelopeIcon}
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="emri@shembull.com"
            />
          </div>

          <Button
            type="submit"
            disabled={loading || !email}
            className="w-full h-11 bg-black hover:bg-zinc-800 text-white font-bold rounded-xl text-sm transition-colors"
          >
            {loading ? (
              <span className="flex items-center justify-center gap-2">
                <ArrowPathIcon className="h-4 w-4 animate-spin" />
                Duke dërguar lidhjen...
              </span>
            ) : (
              'Dërgo lidhjen e rivendosjes'
            )}
          </Button>
        </form>
      )}
    </AuthLayout>
  );
};

export default ForgotPasswordPage;
